export class TOAGameEvent {
    public static readonly UPDATE_REEL_POSITIONS: string = "Update_Reel_Positions";
    public static readonly ON_STONE_PRESS: string = "On_Stone_Pressing";
    public static readonly UPDATE_STONE_WAYS: string = "Update_Ways_On_Stone";
    public static readonly UPDATE_MULTIPLIER: string = "Update_Multiplier";
    public static readonly RESET_MULTIPLIER: string = "Reset_And_Hide_Multiplier";
    public static readonly ON_SPIN_START: string = "On_GameRound_Spin_Start";

    public static readonly ON_NEW_GAME_ROUND: string = "New_Game_Round_Begins";
    public static readonly PLAY_BONUS_SPINE: string = "Play_Bonus_Animations";
    public static readonly BONUS_WIN_NOWIN: string = "Dimmed_SemiDimmed_Syms_While_Bonus_Anticipation";
    public static readonly SYM_STATE_HANDLER: string = "Symbol_State_Handler";
    public static readonly ADD_SYM_STATE_FIRE: string = "Add_Symbol_State_Fire_Animation";
    public static readonly REMOVE_SYM_STATE_FIRE: string = "Remove_Symbol_State_Fire_Animation";
    public static readonly SYM_STATE_FIRE_GO_DARK: string = "Symbol_State_Fire_Tinted";
    public static readonly ON_RESTORE: string = "On_Game_Restore";
    public static readonly PLAY_WILD_LANDING: string = "Play_Wild_Landing";
    public static readonly PLAY_BONUS_IDLE: string = "Play_Bonus_Idle";
    public static readonly ON_SPIN_ABORT: string = "On_Spin_Aborted";
    public static readonly PLAY_WILD_TRANSFORM: string = "Play_Wild_Transform";
    public static readonly SHOW_AWARDED_AKHENATEN_SPINS: string = "Show_Awarded_Akhenaten_spins";
    public static readonly SHOW_AWARDED_SPINS: string = "Show_Awarded_spins";
    public static readonly REMOVE_SCATTER_ANIMS: string = "Remove_All_Scatter_Animations";
    public static readonly START_SHAKE: string = "Start_Shake";
    public static readonly STOP_SHAKE: string = "Stop_Shake";
    public static readonly REMOVE_WILD_LANDING_ANIMS: string = "Remove_Wild_Landing_Anims";
    public static readonly ALL_SPIN_STOP_COMPLETE: string = "All_Spin_Stop_Complete";
    public static readonly UPDATE_REEL_VIEW_BY_REEL_ID: string = "Update_Reel_View_By_Reel_Id";
    public static readonly UPDATE_SPINS_LEFT_METER: string = "Update_Spins_Left_Meter";
    public static readonly PYRAMID_EXPANDING_WILD_ANIM_COMPLETE: string = "Pyramid_Expanding_Wild_Anim_Complete";
    public static readonly PYRAMID_X2_BLAST_ANIM: string = "Play_X2_Blast_Anim";
    public static readonly ALL_PYRAMID_STOPPED: string = "All_Pyramid_Stopped";
    public static readonly ON_PYRAMID_SPINNING_STOPPED: string = "ON_Pyramid_Spinning_Stopped";
    public static readonly ON_PYRAMID_SPINNING_STARTED: string = "ON_Pyramid_Spinning_Started";
    public static readonly ON_GAME_START: string = "On_Game_Start";
    public static readonly HIDE_ALL_PYRAMID: string = "Hide_All_Pyramid";
    public static readonly ON_STONE_PRESS_ABORT: string = "Hide_All_Pyramid";
    public static readonly HIDE_WIN_AMOUNT_BEFORE_MULT_UPDATE: string = "Hide_Win_Amount_Before_Mult_Update";
    public static readonly RE_ARRANGE_REEL_SEQUENCE: string = "Re_Arrange_Sequence";
    public static readonly PLAY_SCATTER_END_ANIM: string = "Scatter_Ending_Animation";


}